module.exports = __webpack_public_path__ + "img/banner-gleede.0bf71c98.svg";